import { useQuery } from 'react-query';

import { useUser } from '~/features/user/hooks/use-user';

import { getWoolfUser } from '../controllers/get-woolf-user';

export function useWoolfUser({ enabled = true }: { enabled?: boolean } = {}) {
  const { jwt, userId } = useUser();
  const wolfUser = useQuery({
    queryKey: ['woolfUser'],
    queryFn: () => {
      if (jwt && userId) {
        return getWoolfUser(jwt, userId);
      }
    },
    enabled: enabled && Boolean(jwt) && Boolean(userId),
  });
  return wolfUser;
}
